import * as vp from 'vopay';
import { FC, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { useNavMenu } from '@/providers/NavMenu.provider';
import { useModuleFeatureFlag } from '@/providers/FeatureFlag.provider';
import { usePartnerLogin } from '@/providers/PartnerLogin.provider';
import { usePartnerData } from '@/providers/PartnerData.provider';
import { useTranslation } from 'react-i18next';

const { NavModule } = vp;

export type NavListProps = {
  onClick: () => void;
};

const NavList: FC<NavListProps> = ({ onClick }: NavListProps) => {
  const history = useHistory();
  const { reset: resetNavMenu } = useNavMenu();
  const { displayAccountProfile } = useModuleFeatureFlag('dashboard');
  const { logout } = usePartnerLogin();
  const { response } = usePartnerData();
  const [isMobile, setIsMobile] = useState(false);
  const [expandMenue, setExpandMenu] = useState(true);
  const { t } = useTranslation('translations', { keyPrefix: 'UI.UserDropDown' });

  window.addEventListener('resize', () => {
    window.innerWidth <= 768 ? setIsMobile(true) : setIsMobile(false);
  });

  useEffect(() => {
    window.innerWidth <= 768 ? setIsMobile(true) : setIsMobile(false);
  }, []);

  useEffect(() => {
    isMobile ? setExpandMenu(false) : setExpandMenu(true);
  }, [isMobile]);

  const isRoleAdmin = response?.isRoleAdmin || false;
  const isRoleViewOnly = response.isRoleViewOnly;

  return (
    <>
      {displayAccountProfile && (
        <NavModule
          id="user-dropdown-my-account"
          label={t('myAccount')}
          icon="myAccount"
          iconHeight="20px"
          activeIcon="myAccountOn"
          iconColor="primary-dark"
          isActive={false}
          variant="2"
          isOpen={false}
          expandMenu={expandMenue}
          onClick={() => {
            onClick();
            resetNavMenu();

            history.push('/dashboard/user/profile');
          }}
          showNavModule={() => true}
        />
      )}

      {(isRoleAdmin || isRoleViewOnly) && (
        <NavModule
          id="user-dropdown-user-managament"
          label={t('userManagement')}
          icon="user"
          iconHeight="20px"
          activeIcon="myTeamOn"
          iconColor="primary-dark"
          isActive={false}
          variant="2"
          isOpen={false}
          expandMenu={expandMenue}
          onClick={() => {
            onClick();
            resetNavMenu();

            history.push('/users');
          }}
          showNavModule={() => true}
        />
      )}

      <NavModule
        id="user-dropdown-logout"
        label={t('logOut')}
        icon="logOut"
        iconHeight="20px"
        activeIcon="logOutOn"
        iconColor="primary-dark"
        isActive={false}
        variant="2"
        isOpen={false}
        expandMenu={expandMenue}
        onClick={logout}
        showNavModule={() => true}
      />
    </>
  );
};

export default NavList;
